module.exports = __webpack_public_path__ + "static/media/drive_1.a3514fcf.jpg";